import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';

import './TopBar.scss';
import FTLogo from './images/logo-horizontal-white.png';

export default function TopBar () {
    const [hasScrolled, setHasScrolled] = useState(false)
  
    useScrollPosition(
      ({ prevPos, currPos }) => {
        const isShow = currPos.y < -30
        setHasScrolled(isShow);
      },
      [hasScrolled],
      null,
      false,
      300
    );
    
    const hasScrolledClass = hasScrolled ?  'has-scrolled' : 'not-has-scrolled';

    return (
        <Navbar className={`top-bar ${hasScrolledClass}`} fixed="top" variant="dark" expand="xl">
            <Navbar.Brand href="/">
                <img src={FTLogo} alt="Fasig Tipton Logo" />
            </Navbar.Brand>
            <Navbar.Text className="mr-auto">
                Since 1898
            </Navbar.Text>
            <Navbar.Toggle  aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="justify-content-end"  id="basic-navbar-nav">
                <Nav>
                    <Nav.Link href="http://www.fasigtipton.com/online-bidding">Bid Online</Nav.Link>
                    <NavDropdown title="Sales" id="sales-dd">
                        <NavDropdown.Item href="http://www.fasigtipton.com/calendar/2026">2026 Calendar</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Catalogues" id="catalogues-dd">
                        <NavDropdown.Item href="http://www.fasigtipton.com/catalogues/2026">2026 Catalogues</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/catalogues/2025">Catalogue Archives</NavDropdown.Item>
                    </NavDropdown>
                    <NavDropdown title="Results" id="results-dd">
                        <NavDropdown.Item href="http://www.fasigtipton.com/results/2026">2026 Results</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/results/2025">Results Archives</NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link href="http://www.fasigtipton.com/forms/buyers">Buyers</Nav.Link>
                    <Nav.Link href="http://www.fasigtipton.com/forms/consignors">Consignors</Nav.Link>
                    <NavDropdown title="About Us" id="about-dd">
                        <NavDropdown.Item href="http://www.fasigtipton.com/about-us">History</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/news">Recent News</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/graded-graduates/2025">Graded Graduates</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/hall-of-fame/2010s">Hall of Fame</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtiptonphotos.com/">Photos</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/staff">Staff</NavDropdown.Item>
                        <NavDropdown.Item href="http://www.fasigtipton.com/locations">Locations</NavDropdown.Item>
                    </NavDropdown>
                </Nav>
            </Navbar.Collapse>
            </Navbar>
    );
}
